import type { TransactionsCountryConfig } from '../TransactionsConfig';

export const transactions: TransactionsCountryConfig = {
    enabled: true,
};
